export const getToken = () => {
  return localStorage.getItem('token');
};

export const getCeId = () => {
  return localStorage.getItem('ce_id') || '';
};

export const setToken = (token: string) => {
  localStorage.setItem('token', token);
};

export const setRole = (role: string) => {
  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:'
      ? '; secure'
      : '';
  document.cookie = `role=${role}; path=/; max-age=3600; samesite=strict${secure}`;
};

export const logout = () => {
  localStorage.removeItem('token');
  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:'
      ? '; secure'
      : '';
  document.cookie = `role=; path=/; max-age=0; samesite=strict${secure}`;
  window.location.href = '/';
};
